// Events for the REC cache.
// TODO consider to place in an object...

const IndividualRefreshEvent = 'rec-cache-individual-refresh'
const IndividualDeleteEvent = 'rec-cache-individual-delete'
const CollectionSizeUpdateEvent = 'rec-cache-collection-size-update'
const CacheUpdateEvent = 'rec-cache-update'
const CacheDeleteEvent = 'rec-cache-delete'

export {
  IndividualRefreshEvent,
  IndividualDeleteEvent,
  CollectionSizeUpdateEvent,
  CacheUpdateEvent,
  CacheDeleteEvent,
}
